import { Link, useLocation, useNavigate } from "react-router-dom";
import { DynamicImage } from "../DynamicImage";
import { PAGE_IMAGE_SLOTS } from "../../lib/page-image-defaults";
import { scrollToSection } from "../../lib/scroll-to-section";
import { CONTACT_EMAIL } from "./Contact";

const footerBannerImage = PAGE_IMAGE_SLOTS.find((s) => s.pagePath === "*" && s.sectionName === "footer_banner")!;

export function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = (sectionId: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    scrollToSection(sectionId, navigate, location.pathname);
  };

  return (
    <footer className="border-t border-slate-200/80">
      <DynamicImage
        pagePath={footerBannerImage.pagePath}
        sectionName={footerBannerImage.sectionName}
        defaultImage={footerBannerImage.defaultImage}
        alt={footerBannerImage.alt}
        wrapperClassName="h-40 w-full md:h-56"
        className="h-full w-full object-cover opacity-90"
      />
      <div className="py-12">
        <div className="container-lux flex flex-col items-start justify-between gap-6 text-sm text-obsidian/50 md:flex-row md:items-center">
          <div>
            <p className="flex items-center gap-2 font-display text-lg text-obsidian">
              {/* Small footer-sized export (h-8 ≈ 32px, rendered at up to 2x for
                  retina ≈ 96px source) instead of the full 800×552 marketing
                  /logo.png (~600KB) — that full-res PNG stays reserved for
                  Open Graph/Twitter previews in index.html, where a large,
                  crisp image is actually the point. See
                  docs/seo-trust-audit.md's Phase 1 Web Vitals item. WebP
                  with a PNG <img> fallback for the handful of browsers/bots
                  that don't support WebP (all evergreen browsers do). */}
              <picture>
                <source srcSet="/logo-footer.webp" type="image/webp" />
                <img src="/logo-footer.png" alt="jyotishASTRO Logo" className="h-8 w-auto" width={96} height={66} />
              </picture>
              Jyotish<span className="text-gold">Astro</span>
            </p>
            <p className="mt-1">© {new Date().getFullYear()} · Vedische Astrologie, mathematisch präzise.</p>
            {/* CC-BY 4.0 attribution requirement for the city/timezone
                dataset bundled at public/data/cities.json, used by the
                real ephemeris calculator (src/lib/ephemeris/cityLookup.ts)
                to resolve birthplace coordinates. Required by GeoNames'
                license terms since we ship their data. */}
            <p className="mt-1 text-[11px] text-obsidian/30">
              Ortsdaten:{" "}
              <a href="https://www.geonames.org" target="_blank" rel="noopener noreferrer" className="underline decoration-obsidian/20 hover:text-gold">
                GeoNames.org
              </a>{" "}
              (CC-BY 4.0)
            </p>
            <p className="mt-1">
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-gold">
                {CONTACT_EMAIL}
              </a>
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            <a href="/#faq" onClick={goToSection("faq")} className="hover:text-gold">FAQ</a>
            <a href="/#contact" onClick={goToSection("contact")} className="hover:text-gold">Kontakt</a>
            <Link to="/angebote" className="hover:text-gold">Angebote</Link>
            <Link to="/vedischer-rechner" className="hover:text-gold">Vedischer Rechner</Link>
            <Link to="/nakshatra-bedeutung" className="hover:text-gold">Nakshatra Bedeutung</Link>
            <Link to="/lebensphasen-dasha" className="hover:text-gold">Lebensphasen &amp; Dasha</Link>
            <Link to="/nakshatras-und-dasha" className="hover:text-gold">Nakshatras &amp; Dasha-System</Link>
            <Link to="/info" className="hover:text-gold">Über uns / Impressum</Link>
            <Link to="/datenschutz" className="hover:text-gold">Datenschutz</Link>
            <Link to="/agb" className="hover:text-gold">AGB</Link>
          </nav>
        </div>
        <div className="container-lux mt-6 flex justify-end">
          <Link to="/login" className="text-[11px] text-obsidian/25 hover:text-obsidian/50">
            Team- &amp; Admin-Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
